export enum EnumExtraFeeProcessingMode {
    CA_PERCENTAGE = 'CA_PERCENTAGE',
    FIXE = 'FIXE',
    DEFINED_QUANTITY = 'DEFINED_QUANTITY',
    NBR_DEVICES = 'NBR_DEVICES',
    NBR_TOTAL_ARTICLES_STOCK = 'NBR_TOTAL_ARTICLES_STOCK',
    NBRE_DE_PORTEURS = 'NBRE_DE_PORTEURS'
}

